import { render, staticRenderFns } from "./ModalWeekSelector.vue?vue&type=template&id=04a00590&"
import script from "./ModalWeekSelector.vue?vue&type=script&lang=js&"
export * from "./ModalWeekSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports